import {Directive, OnInit, Optional, SkipSelf} from '@angular/core';
import {NgControl} from '@angular/forms';
import {UntilDestroy, onDestroy} from '@atlas-angular/rxjs';
import {InputContainer} from '@maia/forms';

/**
 * @ngModule DatePickersModule
 */
@Directive({
  selector:
    // tslint:disable-next-line:directive-selector This directive extends the InputDateComponent
    'maia-input-date[ngModel], maia-input-date[formControl], maia-input-date[formControlName]',
})
@UntilDestroy()
export class InputDateWithControlDirective implements OnInit {
  public constructor(
    private readonly _ngControl: NgControl,
    @Optional() @SkipSelf() private readonly _container?: InputContainer,
  ) {}

  public ngOnInit(): void {
    if (this._container != null) {
      const destroyFn = this._container.registerFormControl(this._ngControl);
      onDestroy(this).subscribe(destroyFn);
    }
  }
}
